import { useQuery } from 'react-query'
import { request } from 'Features/auth/axios-client'

const fetchSORWorkCentreSummary = async (monday: string) => {
  const data = request({
    url: `/system-of-records/work-centre-summary?monday=${monday}`,
    method: 'GET',
  })
  return data
}

export const useSORWorkCentreSummary = (monday: string) => {
  return useQuery(
    ['SORWorkCentreSummary', monday],
    () => fetchSORWorkCentreSummary(monday),
    {
      select: ({ data }) => data?.data,
    }
  )
}
